export const routes = [
    {
        url: '/',
        title: 'Hugo Insurance',
        description: 'Car insurance that fits your paycheck. Hugo let’s you pay at your pace.',
    },
    {
        url: '/about',
        title: 'Hugo Insurance | About Us',
        description: 'We’re on a mission to make car insurance affordable for every American.',
    },
    {
        url: '/error',
        title: 'Hugo Insurance | Page Not Found',
        description: 'Oops, looks like you took a wrong turn!',
    },
    {
        url: '/hex',
        title: 'Hugo Insurance | Hugo Insurance Exchange',
        description: 'Hugo Insurance Exchange.',
    },
    {
        url: '/join',
        title: 'Hugo Insurance | Try Hugo',
        description: 'Try Hugo: no down payments, no upfront fees.',
    },
    {
        url: '/legal',
        title: 'Hugo Insurance | Terms of Use',
        description: 'See our Terms of Use.',
    },
    {
        url: '/licenses',
        title: 'Hugo Insurance | Our Licenses',
        description: 'View our licenses.',
    },
    {
        url: '/lienholder-support',
        title: 'Hugo Insurance | Lienholder Support',
        description: 'Verify the current policy status for a Hugo policy holder.',
    },
    {
        url: '/old-privacy-policy',
        title: 'Hugo Insurance | Old Privacy Policy',
        description: 'This is our old Privacy policy that we keep around for legal reasons.',
    },
    {
        url: '/pay',
        title: 'Hugo Insurance | Flexible Payments',
        description: 'Pay daily, weekly or monthly for car insurance with Hugo.',
    },
    {
        url: '/privacy-form',
        title: 'Hugo Insurance | Privacy Form',
        description: 'Hugo takes protecting your privacy seriously.',
    },
    {
        url: '/reviews',
        title: 'Hugo Insurance | Reviews',
        description: 'See what Hugo members have to say and how we make a difference.',
    },
    {
        url: '/agents',
        title: 'Hugo Insurance | Agents',
        description:
            'Become a Hugo agent and offer affordable, on-demand auto insurance. Win more business, earn strong commissions, and grow with a trusted partner.',
    },
];
